module.exports = __webpack_public_path__ + "static/img/3.bec9628.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/enroll/preview/benjyfishy/3.png
// module id = hFre
// module chunks = 38